module.exports = __webpack_public_path__ + "img/shachenbao.0cde7b07.jpg";